// extracted by mini-css-extract-plugin
export default {"addSuperBatchesButton":"AddSuperBatchesButton_addSuperBatchesButton__jfC+d"};